// extracted by mini-css-extract-plugin
module.exports = {"message":"alartMessageBox_message__CwvmO"};